import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Avatar,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Drawer,
} from "@mui/material";
import { CustomerCSR } from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import ChatPage from "./ChatPage";
import ChatTransfer from "./ChatTransfer";

const ChatList = ({ socketData }) => {
  const listRef = useRef(null);
  const [selectedUser, setSelectedUser] = useState("");
  const [users, setUsers] = useState([]);
  const [latestSocketId, setLatestSocketId] = useState(null);
  const [unreadIds, setUnreadIds] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };

  const fetchData = async () => {
    const resp = await CustomerCSR();
    if (resp?.status === 200) {
      const filtered = resp.data.data.filter(
        (user) => user.teamMemberId === null
      );
      setUsers(filtered);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (socketData?.conversationId) {
      setLatestSocketId(socketData.conversationId);
      setUnreadIds((prev) =>
        prev.includes(socketData.conversationId)
          ? prev
          : [socketData.conversationId, ...prev]
      );
    }
  }, [socketData]);

  useEffect(() => {
    if (!latestSocketId) return;

    const matchedUser = users.find(
      (u) => u.id === latestSocketId && u.teamMemberId === null
    );

    if (matchedUser) {
      const others = users.filter((u) => u.id !== matchedUser.id);
      setUsers([matchedUser, ...others]);
      if (listRef.current) listRef.current.scrollTop = 0;
    }

    setLatestSocketId(null);
  }, [latestSocketId, users]);

  return (
    <Box
      display="flex"
      height="100vh"
      sx={{ background: "linear-gradient(#e3f6f5, #c3b5fd54)" }}
      width={"100%"}
      overflowY={"hidden"}
    >
      {/* Sidebar */}
      <Box
        width="20%"
        sx={{
          backgroundColor: "#f3f3f3",
          borderRight: "1px solid #ccc",
          borderRadius: "13px",
          p: 1,
          m: 1,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontSize: { lg: "20px", xs: "13px" } }}
          p={2}
        >
          Chats
        </Typography>
        <Divider />
        <List
          ref={listRef}
          sx={{
            height: "80vh",
            overflowY: "scroll",
            "&::-webkit-scrollbar": { width: "6px" },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ccc",
              borderRadius: "4px",
            },
          }}
        >
          {users.length > 0 ? (
            <>
              {users.map((item) => (
                <>
                  <ListItem
                    button
                    key={item?.id}
                    selected={selectedUser?.id === item.id}
                    onClick={() => {
                      setUnreadIds((prev) =>
                        prev.filter((id) => id !== item.id)
                      );
                      setSelectedUser(item);
                    }}
                    sx={{
                      borderRadius: "13px",
                      m: 0.5,
                      width: "95%",
                      cursor: "pointer",
                      background:
                        selectedUser?.id === item.id
                          ? "linear-gradient(to right, #8832d1, #11c8d8)"
                          : "transparent",
                      color: selectedUser?.id === item.id ? "white" : "black",
                      "&:hover": {
                        background:
                          "linear-gradient(to right, #8832d1, #11c8d8)",
                        color: "white",
                      },
                    }}
                  >
                    <ListItemAvatar
                      sx={{ display: { lg: "flex", xs: "none" } }}
                    >
                      <Avatar src={fileUrl + item?.customer?.picture} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Box display="flex" alignItems="center">
                          <Typography
                            fontSize={{ lg: "15px", xs: "11px" }}
                            sx={{ flexGrow: 1 }}
                          >
                            {item?.customer?.name}
                          </Typography>
                          {unreadIds.includes(item.id) && (
                            <Box
                              sx={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: "red",
                                ml: 1,
                              }}
                            />
                          )}
                        </Box>
                      }
                    />
                  </ListItem>
                </>
              ))}
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "90vh",
              }}
            >
              <Typography>No Chat List</Typography>
            </Box>
          )}
        </List>
      </Box>

      {/* Chat Area */}
      <Box
        sx={{
          width: "80%",
          // width: selectedUser ? "50%" : "80%",
          display: "flex",
          flexDirection: "column",
          // borderRight: "1px solid #ccc",
          height: "100vh",
        }}
      >
        <ChatPage
          selectedUser={selectedUser}
          socketData={socketData}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
        />
      </Box>

      {/* Transfer Panel */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: { width: { xs: "80%", sm: "400px" } }, // optional, control width
        }}
      >
        <ChatTransfer
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          handleSuccess={fetchData}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
        />
      </Drawer>
      {/* {selectedUser && (
        <Box
          sx={{
            width: "30%",
            display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #ccc",
            height: "85vh",
            borderRadius: "13px",
            p: 1,
          }}
        >
          <ChatTransfer
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            handleSuccess={fetchData}
          />
        </Box>
      )} */}
    </Box>
  );
};

export default ChatList;
